import React from 'react';

/**
 * LayoutSkeleton component
 *
 * Provides a skeleton loading state for the main layout structure
 * with navbar and content area.
 */
export const LayoutSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#F5F8F9] relative">
      <div className="max-w-[1920px] mx-auto relative">
        {/* Sidebar Skeleton */}
        <div className="fixed top-0 left-0 bottom-0 w-64 bg-white shadow-sm hidden lg:block z-10">
          {/* Logo placeholder */}
          <div className="h-16 border-b border-gray-100 flex items-center px-6">
            <div className="bg-gray-200 h-8 w-36 rounded-md animate-pulse"></div>
          </div>

          {/* Navigation items */}
          <div className="p-4 space-y-3">
            {[...Array(8)].map((_, i) => (
              <div
                key={i}
                className="flex items-center space-x-3 p-3 rounded-lg"
                style={{ animationDelay: `${i * 0.05}s` }}
              >
                <div className="w-6 h-6 rounded-md bg-gray-200 animate-pulse"></div>
                <div className="h-5 bg-gray-200 rounded-md animate-pulse w-24"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Top Navbar Skeleton */}
        <div className="h-16 bg-white border-b border-gray-100 fixed top-0 left-0 right-0 z-10 lg:pl-64">
          <div className="flex items-center justify-between h-full px-6">
            {/* Left Side */}
            <div className="flex items-center lg:hidden">
              <div className="w-6 h-6 rounded-md bg-gray-200 animate-pulse"></div>
            </div>

            {/* Right Side */}
            <div className="flex items-center space-x-4 ml-auto">
              <div className="w-8 h-8 rounded-full bg-gray-200 animate-pulse"></div>
              <div className="w-8 h-8 rounded-full bg-gray-200 animate-pulse"></div>
              <div className="w-32 h-8 bg-gray-200 rounded-full animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Main Content Skeleton */}
        <div className="pt-16 lg:pl-64 w-full">
          <div className="p-6 space-y-6">
            {/* Page Header */}
            <div className="space-y-2">
              <div className="h-8 bg-gray-200 w-1/4 rounded-md animate-pulse"></div>
              <div className="h-5 bg-gray-200 w-2/5 rounded-md animate-pulse"></div>
            </div>

            {/* Content Placeholder */}
            <div className="bg-white rounded-xl h-[calc(100vh-180px)] w-full animate-pulse opacity-50"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
